import type { FilterOption } from '@/scopes/search/types'
import { useIntl } from '@/intl'
import * as TransportTypeFilterPrimitive from '@/scopes/common/components/Filters/TransportTypeFilterPrimitive'
import * as DialogPrimitive from '@/scopes/search/components/QuickSearchBarLegacy/DialogPrimitive'
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBarLegacy/store'
import {
  Button,
  Icon,
  SheetClose,
  SheetContentWrapper,
  SheetHeader,
  SheetTitle,
  Typography,
} from '@sunwebgroup/ui-components'
import * as React from 'react'
import { Item } from './QuickSearchBarLegacy'

export function TransportTypeFilterComponent({
  disabled,
  onConfirm,
  options,
  selectedOption,
}: {
  disabled?: boolean
  onConfirm: (selection: string) => void
  options: FilterOption<string>[]
  selectedOption: string | undefined
}) {
  const intl = useIntl()
  const { setActiveItem } = useQuickSearchStore()

  const handleFilterChange = (selection: string) => {
    onConfirm(selection)
    setActiveItem(null)
  }

  const handleClose = () => {
    setActiveItem(null)
  }

  const formattedText = options.find(option => option.value === selectedOption)?.name || ''

  return (
    <Item.Root
      id="travel-transport-type-filter"
      icon="IconClock"
      placeholder={intl.formatMessage({
        id: 'transport_type_options_label',
      })}
      title={intl.formatMessage({
        id: 'transport_type_label',
      })}
      onClose={handleClose}
    >
      <Item.AsPopover selectionFormattedText={formattedText} disabled={disabled} data-qa="transport-type-filter">
        <TransportTypeFilterPrimitive.Root
          onSelectedValueChange={handleFilterChange}
          selectedOption={selectedOption}
          options={options}
          disabled={disabled}
        />
      </Item.AsPopover>
      <Item.AsSheet selectionFormattedText={formattedText} disabled={disabled} data-qa="transport-type-filter">
        <>
          <SheetHeader>
            <SheetTitle>{intl.formatMessage({ id: 'transport_type_label' })}</SheetTitle>
            <SheetClose>{intl.formatMessage({ id: 'quicksearch_cancel_button_text' })}</SheetClose>
          </SheetHeader>
          <SheetContentWrapper>
            <TransportTypeFilterPrimitive.Root
              onSelectedValueChange={handleFilterChange}
              selectedOption={selectedOption}
              options={options}
              disabled={disabled}
            />
          </SheetContentWrapper>
        </>
      </Item.AsSheet>
      <Item.AsDialog selectionFormattedText={formattedText} disabled={disabled} data-qa="transport-type-filter">
        <DialogPrimitive.Root>
          <DialogPrimitive.Header>
            <DialogPrimitive.HeaderTitle>
              <Typography $variant="body-lg-bold">
                {intl.formatMessage({ id: 'transport_type_label' })}
              </Typography>
              <Button onClick={handleClose} $hierarchy="tertiary" $withoutColor>
                <Icon glyph="IconCrossMedium" size="md" />
              </Button>
            </DialogPrimitive.HeaderTitle>
          </DialogPrimitive.Header>
          <DialogPrimitive.Body>
            <TransportTypeFilterPrimitive.Root
              onSelectedValueChange={handleFilterChange}
              selectedOption={selectedOption}
              options={options}
              disabled={disabled}
            />
          </DialogPrimitive.Body>
        </DialogPrimitive.Root>
      </Item.AsDialog>
      <Item.AsIcon
        selectionFormattedText={formattedText}
        compactSelectionFormattedText={formattedText}
      />
    </Item.Root>
  )
}
